import React from 'react'

import InfoIcon from '@src/components/icons/Info'
import PointIcon from '@src/components/icons/Point'
import { MILES_WIDGET_TOOLTIP } from '@src/constants/exchange'

interface IMilesTrackerProp {
    miles: number
    tooltipPosition?: 'left' | 'bottom' | 'top-left'
}

const MilesTracker: React.FC<IMilesTrackerProp> = ({ miles, tooltipPosition = 'bottom' }: IMilesTrackerProp) => {
    const [showTooltip, setShowTooltip] = React.useState(false)

    // Utility function to transform the passed tooltipPosition prop to classes to position the tooltip
    const getTooltipPositionClasses = () => {
        switch (tooltipPosition) {
            case 'left':
                return 'right-full top-1/2 mr-2 -translate-y-1/2'
            case 'top-left':
                return 'bottom-full right-0 mb-2'
            case 'bottom':
            default:
                return 'top-full left-1/2 mt-2 -translate-x-1/2'
        }
    }

    return (
        <div className='animate-fade-in-up flex flex-1 items-center gap-2 rounded-[10px] bg-[#0A2811] p-2'>
            <div className='flex flex-1 items-center gap-2'>
                <PointIcon className='h-4 w-4' />
                <span className='text-fluid-sm !leading-5 text-[#29A74D]'>
                    +{miles.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} Miles
                </span>
            </div>
            <div
                className='relative'
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            >
                <InfoIcon className='h-4 w-4 cursor-help text-[#29A74D]' />
                {showTooltip && (
                    <div
                        className={`absolute z-[700000] inline-flex w-64 transform flex-col items-start justify-start gap-2 rounded-md bg-[#212326] p-4 opacity-100 shadow-[0px_10px_30px_rgba(0,0,0,0.35)] ${getTooltipPositionClasses()}`}
                    >
                        <div className='break-words text-center text-xs font-normal leading-4 text-[#757575]'>
                            {MILES_WIDGET_TOOLTIP}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default MilesTracker
